<template>
  <div>
    <div class="table-responsive">
      <table class="table table-sm table-tp table-striped table-middle fs-sm">
        <thead>
          <tr>
            <th v-if="$root.user.isAdmin" class="th-shrink" />
            <th />
            <th class="text-right bg-white">Množstvo (MWh)</th>
            <th class="text-right bg-white">Množstvo (m3)</th>
            <th class="text-right bg-white">Max. odber DMM (m3)</th>
            <th class="text-right bg-white">Prekročenie DMM (m3)</th>
            <th class="text-right bg-white">Celková cena (€ bez dph)</th>
            <th class="text-right bg-white">
              Priem. jedn. cena (€ bez dph/MWh)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td v-if="$root.user.isAdmin">
              <b-dropdown variant="link" no-caret class="btn-p-0">
                <template slot="button-content">
                  <b-icon icon="text-indent-left" scale="1.25x" />
                </template>
                <b-dropdown-item @click.prevent="edit(item.id)">
                  <b-icon icon="pencil-square" class="mr-1" />
                  Upraviť
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-danger"
                  @click.prevent="remove(item.id)"
                >
                  <b-icon icon="trash" class="mr-1" />
                  Vymazať
                </b-dropdown-item>
              </b-dropdown>
            </td>
            <td class="text-nowrap font-weight-bold">
              <template v-if="isYearly(item.reportDate)"> Celkom </template>
              <template v-else>
                {{ item.reportDate | formatMonths }}
              </template>
            </td>
            <td class="text-right">
              <template v-if="item.soPo != null">
                {{ item.soPo | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.consumption != null">
                {{ item.consumption | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.quantity != null">
                {{ item.quantity | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.overDDK != null">
                {{ item.overDDK | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.totalPrice != null">
                {{ item.totalPrice | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.priceUnit != null">
                {{ item.priceUnit | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td v-if="$root.user.isAdmin" />
            <td colspan="5" />
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumTotalPrice | formatNumber(2)
              }}</span>
            </td>
            <td colspan="3" />
          </tr>
        </tfoot>
      </table>
    </div>
    <b-row v-if="report" class="align-items-center mt-2 mb-4">
      <b-col cols="6" md="3" sm="4">
        <div
          :class="[
            report.report.totalSopo ? 'text-danger font-weight-bold' : '',
          ]"
          class="text-center"
        >
          <div>Ročné množstvo (MWh)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.totalSopo | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="6" md="3" sm="4">
        <div
          :class="[
            report.report.totalConsumption
              ? 'text-danger font-weight-bold'
              : '',
          ]"
          class="text-center"
        >
          <div>Ročné množstvo (m3)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.totalConsumption | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="6" md="3" sm="4">
        <div
          :class="[report.report.diffYC ? 'text-danger font-weight-bold' : '']"
          class="text-center"
        >
          <div>Rozdiel odobraté a objednané množstvo (MWh)</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.diffYC | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
      <b-col cols="6" md="3" sm="4">
        <div
          :class="[
            report.report.percDiff ? 'text-danger font-weight-bold' : '',
          ]"
          class="text-center"
        >
          <div>Rozdiel v %</div>
          <hr class="my-1" />
          <h4 class="m-0">
            {{ report.percDiff | formatNumber(2) }}
          </h4>
        </div>
      </b-col>
    </b-row>
    <gas-chart :data="chartData" />
    <hr />
    <div class="mb-5">
      <h4>
        <b-icon icon="pencil" />
        Poznámky
        <transition name="fadeRightShort">
          <b-badge v-if="noteSaved" variant="primary">
            {{ noteSaved }}
          </b-badge>
        </transition>
      </h4>
      <b-form-textarea
        v-if="$root.user.isAdmin"
        v-model="note"
        placeholder="žiadne poznámky (kliknutím pridajte)"
        rows="4"
        @blur="$emit('onNoteChange', note)"
      />
      <div
        v-else
        class="h-auto form-control"
        v-html="note ? $options.filters.nl2br(note) : '-'"
      />
    </div>
  </div>
</template>
<script>
import GasChart from './Chart'

export default {
  components: {
    GasChart,
  },
  props: ['chartData', 'data', 'report', 'note'],
  data() {
    return {
      noteSaved: null,
    }
  },
  computed: {
    sumTotalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.totalPrice
      }, 0)
    },
  },
  methods: {
    edit(id) {
      this.$root.$emit('reports.openConsumerModal', { id: id })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
    isYearly(date) {
      return this.$moment(date, 'YYYY-MM-DD').format('DD.MM') == '31.12'
        ? true
        : false
    },
  },
}
</script>
